var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamUnilions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.98 59.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fe6809;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5167\\u5BB9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nJqJWx.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46,59.54H14.47v-52h7.74v46H46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.9,0a15.65,15.65,0,0,0-.69,5.81c0,11.62,0,23.23,0,34.3.89,2.33,2.58,2.87,4.2,3.56v5.91C5.32,49.86.83,45.66.82,38.79q0-17.07,0-34.12A8.71,8.71,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.34,0a31,31,0,0,0-.59,7.33q0,15.76,0,31.54c0,6.88-4,10.7-11.25,10.78-.51-1.91-.1-3.86-.23-5.67,1.24-1.15,3-1.21,3.7-2.67a8.16,8.16,0,0,0,.39-3.64q0-16.51,0-33c0-1.62,0-3.23-.93-4.64Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamUnilions);
export default __webpack_public_path__ + "static/media/team_unilions.04c5926bfd8afc1f63c09e62d43fd97a.svg";
export { ForwardRef as ReactComponent };